import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { CategoriesService } from '../home/categories/services/categories.service';
import { catchError, from, map, of } from 'rxjs';
import { BenefitsService } from '../home/services/benefits.service';

export const TypeBeneficiariesResolverService: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(CategoriesService).getBeneficiaryTypes()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};

export const GeneralBenefitsResolverService: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(BenefitsService).getBenefitsGeneral()).pipe(
    map((benefits: any[] = []) =>
      benefits.filter(
        b => typeof b?.link === 'string' && b.link.startsWith('/form/')
      )
    ),
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};
